import React from "react";

// Lib
import { sanitize } from "dompurify";
import { shallowEqual } from "react-redux";
import { getImageSources } from 'lib/libraries';
import { decodeHtmlEntity, filteredDataByKey } from "lib/helpers";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// Constants
import config from "lib/config";

// components
import Img from "components/Img";

// Actions
import { openModal } from "reducers/modal";

export const Description: React.FC = () => {
  const dispatch = useAppDispatch();

  const { lib, compoundsCount } = useAppSelector(
    (store) => {
      return {
        lib: store.librariesProduct?.libDetailsData?.lib || {},
        compoundsCount: store.librariesProduct?.libDetailsData?.lib?.compoundsCount || '',
      };
    },
    shallowEqual
  );

  const {
    imgRight,
    imgCenter,
    srcRight,
    srcCenter
  } = getImageSources({
    lib,
    config,
    filterFn: filteredDataByKey,
  });

  const handlerClickBanner = () => {
    dispatch(openModal({
      type: "bunner",
      url: srcRight || srcCenter
    }));
  };

  const descriptionImg1 = sanitize(
    decodeHtmlEntity(lib?.imgRightDescr || "") || ""
  );
  const descriptionGen = sanitize(
    decodeHtmlEntity(lib?.descriptionGen
      ? lib?.descriptionGen?.replaceAll("#cmpCount#", `${compoundsCount}`) || ""
      : "") || "General description is empty"
  );

  return (
    <>
      <div className="libraries-description__content flex flex-ai-start">
        <p
          className="libraries-description__text ql-editor"
          dangerouslySetInnerHTML={
            { __html: descriptionGen }
          }
        />
        {!!imgRight?.length && <div className="libraries-description__wrapper-img">
          <div onClick={handlerClickBanner}>
            <Img
              isPreloader
              innerSrc={srcRight}
              alt="Image molecule fileNameImg1"
              className="libraries-description__img"
              classNameSvgError="libraries-description__img"
            />
          </div>

          {!!imgRight?.length &&
            <p className="libraries-description__figure flex flex-ai-start ql-editor full-width">
              <span
                className="full-width"
                dangerouslySetInnerHTML={
                  { __html: descriptionImg1 }
                }
              />
            </p>}
        </div>}
      </div>

      {!!imgCenter?.length && <div
        style={{ marginLeft: 0 }}
        onClick={handlerClickBanner}
        className="libraries-description__wrapper-img-center libraries-description__wrapper-img--canvas"
      >
        <Img
          isPreloader
          innerSrc={srcCenter}
          alt="Image molecule fileNameImg3"
          className="libraries-description__img3 mt30"
        />
      </div>}
    </>
  );
};

export default Description;